<template>
  <header class="header">
    <div class="container header-content">
      <div class="logo">
        <!-- <i class="fas fa-heart"></i> -->
        <span>椰糕🥥🍰</span>
      </div>

      <nav class="nav">
        <ul class="nav-links" :class="{ active: mobileMenuOpen }">
          <li v-for="(section, index) in sections" :key="index">
            <router-link
              :to="section.path"
              :class="{ active: $route.path === section.path }"
              @click.native="mobileMenuOpen = false"
            >
              <i :class="section.icon"></i>
              {{ section.name }}
            </router-link>
          </li>
        </ul>
        <div class="hamburger" @click="mobileMenuOpen = !mobileMenuOpen">
          <i class="fas fa-bars"></i>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "SiteHeader",
  data() {
    return {
      mobileMenuOpen: false,
      sections: [
        { path: "/", name: "首页", icon: "fas fa-home" },
        { path: "/intro", name: "个人简介", icon: "fas fa-user-friends" },
        // { path: "/news", name: "新闻板块", icon: "fas fa-newspaper" },
        // { path: "/gaogao", name: "糕糕板块", icon: "fas fa-birthday-cake" },
        // { path: "/xiaoye", name: "小椰板块", icon: "fas fa-camera" },
        { path: "/material", name: "物料补档", icon: "fas fa-archive" },
        { path: "/data", name: "数据记录", icon: "fas fa-chart-line" },
        { path: "/design", name: "设计爱情", icon: "fas fa-paint-brush" },
        { path: "/literature", name: "文学创作", icon: "fas fa-book-open" },
      ],
    };
  },
  methods: {
    handleResize() {
      if (window.innerWidth > 768) {
        this.mobileMenuOpen = false;
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
/* 头部样式将放在全局CSS中 */
</style>
